<template>
  <section class="grey_bg" aria-labelledby="complaints-heading">
    <div class="container mt-4">
<h1 id="complaints-heading" class="mt-4 page-title">Investor Complaints</h1>
<h2 id="complaint-data-heading" class="mt-4">Complaint Data</h2>
<p><span>Data for the month ending &ndash; October 2025.</span></p>
<div class="table-responsive">
<table class="table table-bordered" aria-labelledby="complaint-data-heading">
<caption class="visible-caption">Complaint Data &mdash; for the month ending October 2025</caption>
<thead>
<tr>
<th scope="col">Sr. No.</th>
<th scope="col">Received from</th>
<th scope="col">Pending at the end of last month</th>
<th scope="col">Received</th>
<th scope="col">Resolved *</th>
<th scope="col">Total Pending#</th>
<th scope="col">Pending complaints &gt; 3 months</th>
<th scope="col">Average Resolution time^ (in days)</th>
</tr>
</thead>
<tbody>
<tr>
<td>
<p><b>1</b></p>
</td>
<td>
<p><span >Directly from Investors</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
</tr>
<tr>
<td>
<p><b>2</b></p>
</td>
<td>
<p><span >SEBI (SCORE S)&nbsp;</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
</tr>
<tr>
<td>
<p><b>3</b></p>
</td>
<td>
<p><span >Other Sources (if any)&nbsp;</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
</tr>
<tr>
<td></td>
<td>
<p><span >Grand Total</span></p>
</td>
<td><br />
<p><span >-</span></p>
</td>
<td><br />
<p><span >&nbsp;-</span></p>
</td>
<td><br />
<p><span >&nbsp;-</span></p>
</td>
<td><br />
<p><span >&nbsp;-</span></p>
</td>
<td><br />
<p><span >&nbsp;-</span></p>
</td>
<td><br />
<p><span >&nbsp;-</span></p>
</td>
</tr>
</tbody>
</table>
</div>

<p>Number of complaints received during month against the RA due to impersonation by
  some other entity:</p>

<p>* Inclusive of complaints of previous months resolved in the current month.</p>
<p># Inclusive of complaints pending as on the last day of the month.</p>
<p><strong>Note:</strong> In case of any complaints received against the RA due to impersonation of the RA
by some other entity, the RA may adjust the number of such complaints from total number
of received/resolved complaints while preparing the above table. Further, RA must close
such impersonation related complaints after following the due process as specified by SEBI/
RAASB.</p>

<p><span >^ Average Resolution time is the sum total of time taken to resolve each complaint in days, in the current month divided by total number of complaints resolved in the current month.&nbsp;</span></p>
<h2 id="monthly-disposal-heading" class="mt-4">Trend of monthly disposal of complaints</h2>


<div class="table-responsive">
<table class="table table-bordered" aria-labelledby="monthly-disposal-heading">
  <caption class="visible-caption">Trend of monthly disposal of complaints</caption>
  <thead>
    <tr>
      <th scope="col">Sr. No.</th>
      <th scope="col">Month</th>
      <th scope="col">Carried forward from previous month</th>
      <th scope="col">Received</th>
      <th scope="col">Resolved*</th>
      <th scope="col">Pending#</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <p><span>1</span></p>
      </td>
      <td>
        <p><span>April 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
   <tr>
      <td>
        <p><span>2</span></p>
      </td>
      <td>
        <p><span>May 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>3</span></p>
      </td>
      <td>
        <p><span>June 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>3</span></p>
      </td>
      <td>
        <p><span>July 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

      <tr>
      <td>
        <p><span>4</span></p>
      </td>
      <td>
        <p><span>August 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

    <tr>
      <td>
        <p><span>5</span></p>
      </td>
      <td>
        <p><span>September 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>5</span></p>
      </td>
      <td>
        <p><span>October 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>6</span></p>
      </td>
      <td>
        <p><span>November 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>7</span></p>
      </td>
      <td>
        <p><span>December 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>8</span></p>
      </td>
      <td>
        <p><span>January 2026</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
     <tr>
      <td>
        <p><span>9</span></p>
      </td>
      <td>
        <p><span>February 2026</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
     <tr>
      <td>
        <p><span>10</span></p>
      </td>
      <td>
        <p><span>March 2026</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

    <tr>
      <td>
        <p><span></span></p>
      </td>
      <td>
        <p><span>Grand Total</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

    <!--
    <tr>
      <td>
        <p><span>3</span></p>
      </td>
      <td>
        <p><span>June 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>4</span></p>
      </td>
      <td>
        <p><span>July 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>5</span></p>
      </td>
      <td>
        <p><span>August 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>6</span></p>
      </td>
      <td>
        <p><span>September 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>7</span></p>
      </td>
      <td>
        <p><span>October 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>8</span></p>
      </td>
      <td>
        <p><span>November 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>9</span></p>
      </td>
      <td>
        <p><span>December 2024</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>
    <tr>
      <td>
        <p><span>10</span></p>
      </td>
      <td>
        <p><span>January 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>

     <tr>
      <td>
        <p><span>11</span></p>
      </td>
      <td>
        <p><span>February 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr>


    <tr>
      <td>
        <p><span>12</span></p>
      </td>
      <td>
        <p><span>March 2025</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
      <td>
        <p><span>-</span></p>
      </td>
    </tr> -->

  </tbody>
</table>
</div>

<p></p>
<p><span >*Inclusive of complaints of previous months resolved in the current month.</span></p>
<p><span >&nbsp;#Inclusive of complaints pending as on the last day of the month.&nbsp;</span></p>
<h2 id="annual-disposal-heading">Trend of annual disposal of complaints</h2>
<div class="table-responsive">
<table class="table table-bordered" aria-labelledby="annual-disposal-heading">
<caption class="visible-caption">Trend of annual disposal of complaints</caption>
<thead>
<tr>
<th scope="col">SN</th>
<th scope="col">Year</th>
<th scope="col">Carried forward from previous year</th>
<th scope="col">Received</th>
<th scope="col">Resolved*</th>
<th scope="col">Pending#</th>
</tr>
</thead>
<tbody>


<tr>
<td>
<p><span >1</span></p>
</td>
<td>
<p><span >2022-23</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
</tr>


<tr>
<td>
<p><span >2</span></p>
</td>
<td>
<p><span >2023-24</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
</tr>


<tr>
<td>
<p><span >3</span></p>
</td>
<td>
<p><span >2024-25</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
</tr>

<tr>
<td>
<p><span >4</span></p>
</td>
<td>
<p><span >2025-26</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
</tr>
<tr>
<td></td>
<td>
<p><span >Grand Total</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
<td>
<p><span > -</span></p>
</td>
</tr>
</tbody>
</table>
</div>
<p></p>
<p><span >*Inclusive of complaints of previous years resolved in the current year.&nbsp;</span></p>
<p><span >#Inclusive of complaints pending as on the last day of the year. </span></p>
    </div>
  </section>
</template>

<script>
  export default {
    name: "InvestorComplaints",
    mounted() {
      document.title = "Investor Complaints | Grow With Stocks";
    }
  };
</script>


<style lang="scss" scoped>
  .btn_custom {
    background-color: #1a7055 !important;
    color: #fff !important;
    font-weight: 600;
    margin: auto;
    height: 50px;
    width: auto;
  }
  .fullPage {
    min-height: 100vh;
  }
  td, th {
    padding: 13px;
  }
  th[scope="col"] {
    background-color: #1a7055;
    color: #fff;
    font-weight: 700;
    text-align: left;
  }
  #contactus_social {
    padding: 0;
  }
  .page-title {
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 12px;
  }
  h2 {
    font-size: 22px;
    font-weight: 700;
    margin-top: 28px;
    margin-bottom: 12px;
  }
  .sr-only {
    position: absolute !important;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .grey_bg {
    background: #f7f7f7;
    padding-bottom: 40px;
  }
  /*==========  Mobile First Method  ==========*/

  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (min-width: 992px) {
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 1200px) {
  }

  /*==========  Non-Mobile First Method  ==========*/

  /* Large Devices, Wide Screens */
  @media only screen and (max-width: 1200px) {
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (max-width: 768px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width: 480px) {
    .btn_contact {
      display: block;
      margin: auto;
    }
  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width: 320px) {
  }

  /* WCAG 1.3.1 — visible table caption so it's reliably announced and seen */
  .visible-caption {
    caption-side: top;
    text-align: left;
    padding: 8px 4px;
    font-weight: 600;
    font-size: 16px;
    color: #2d2d2d;
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// src/views/InvestorComplaints.vue